export enum AuthUrls {
  Login = "/v1/Authentication",
  LoginWithOTP = "/v1/Authentication/SecondFactor",
  IdentifyUser = "/v1/User/Identify",
  IdentifyUserByUsername = "/v1/User/IdentifyByUsername",
  SendVerificationCode = "/v1/Verification/OTP",
  CheckVerificationCode = "/v1/Verification/OTP/Verify",
  ResetPassword = "/v1/User/Activation/ResetPassword",
  RefreshToken = "/v1/Authentication/Refresh",
  SignOut = "/v1/Authentication/SignOut",
  QR = "/v1/Authentication/QR",
  QRStatus = "/v1/Authentication/QR/Status",
  QRExchange = "/v1/Authentication/QR/Exchange",
}

export enum ResetMethodTab {
  Account = "account",
  Card = "card",
}

export enum ResetStepper {
  StepOne = 1,
  StepTwo = 2,
  StepThree = 3,
  StepFour = 4,
}

export enum Reset {
  Username = "username",
  Password = "password",
  ConfirmPassword = "confirmPassword",
  AccountNumber = "accountNumber",
  CardNumber = "cardNumber",
  OTP = "otp",
}

export enum UserIdentifyType {
  Account = "Account",
  Card = "Card",
}

export enum UserVerificationType {
  Email = "email",
  SMS = "sms",
}

export enum TokenType {
  Hard = "Hard",
  Soft = "Soft",
  None = "None",
}

export enum QrSessionState {
  None = 0,
  Created = 1,
  Scanned = 2,
  Canceled = 3,
  Approved = 4,
  Expired = 5,
  Failed = 6,
}

export enum QrLoginEventNames {
  Terminal = "terminal",
  State = "state",
  Ping = "ping",
}
